import type { TranslatedString } from '@interfaces/shared';
import { Box, CircularProgress, Typography } from 'hephaestus/web';
import { useTranslation } from 'react-i18next';
import { useLocalization } from '../../../../../../hooks/useLocalization';

export const ArchivingAsynchronousMessage = ({
  presentObjectTypes,
}: {
  presentObjectTypes?: string;
}) => {
  const { t } = useTranslation(['workflowCompletions']);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 8,
        gap: 2,
      }}
    >
      <CircularProgress />
      <Typography variant='bodyMedium' sx={{ fontWeight: 500 }}>
        {t('workflowCompletions:archiveObjects.archivingMessage', {
          objects: presentObjectTypes,
        })}
      </Typography>
    </Box>
  );
};

export const ArchivingSynchronousMessage = ({
  title,
  subtitle,
}: {
  readonly title: TranslatedString;
  readonly subtitle?: TranslatedString;
}) => {
  const { translateBackendString } = useLocalization();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 8,
        gap: 2,
      }}
    >
      <CircularProgress />
      <Typography variant='headingMedium'>
        {translateBackendString(title)}
      </Typography>
      {subtitle && (
        <Typography variant='bodyMedium' sx={{ fontWeight: 500 }}>
          {translateBackendString(subtitle)}
        </Typography>
      )}
    </Box>
  );
};
